import * as React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import * as shamsi from 'shamsi-date-converter';
import "react-multi-date-picker/styles/layouts/mobile.css"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import Select from "react-select";


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);



let label = [];
let labelAmp = [];
let count = [];
let countAmp = [];


export default function Sales() {

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [dateFrom, setDateFrom] = React.useState('');
    const [dateTo, setDateTo] = React.useState('');
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState();
    const [duration, setDuration] = React.useState('سی روز گذشته');
    const [basics, setBasics] = React.useState([]);
    const [brand, setBrand] = React.useState('');
    const [amperage, setAmperage] = React.useState('');
    const [type, setType] = React.useState('');

    React.useEffect(() => {

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        var priorDate = new Date(new Date().setDate(today.getDate() - 30));
        var dd2 = String(priorDate.getDate()).padStart(2, '0');
        var mm2 = String(priorDate.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy2 = priorDate.getFullYear();
        today =  yyyy + '-' +  mm   + '-' + dd;
        priorDate =   yyyy2 + '-' + mm2 + '-' + dd2;

        const params = {
            date_from :  priorDate,
            date_to : today ,
        }
        API.getSalesChart(params)
            .then((response) => {
                label = [];
                count = [];

                response.data.saleDay.forEach(element => {

                    label.push(shamsi.gregorianToJalali(element.date).join('/'));
                    count.push(element.count);
                });

                response.data.saleAmp.forEach(element => {

                    labelAmp.push(shamsi.gregorianToJalali(element.date).join('/'));
                    countAmp.push(element.count);
                });

                const params = {
                    list: 1,
                    count: 500,
                    processFor: 'Sales',
                }
                API.getVendors(params)
                    .then((response) => {


                        const vendors = response.data;
                        let options = [];
                        for (let data in vendors) {

                            options.push({
                                value: vendors[data].id,
                                label: vendors[data].title + " - " + vendors[data].city,
                            })
                        }
                        setSelectOptions(options)

                        API.getBasics(params)
                            .then((response) => {
                                setBasics(response.data)
                                setIsLoaded(true)
                            })
                            .catch((error) => {

                            });
                    })

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, []);

    const onLoadReport = () => {


        if(dateFrom.length < 3 || dateTo.length < 3) {
            toast.error('بازه تاریخی را انتخاب کنید');
            return false
        }

        const toMonth = dateTo?.toDate?.().getMonth() -(-1);
        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const params = {
            vendor_id: selectedOptions?.value,
            brand_id: brand,
            amperage,
            type,
            date_from : dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' + dateFrom?.toDate?.().getDate() + ' 00:00' ,
            date_to : dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59' ,
        }
        setIsLoaded(false)
        setDuration('بر اساس پارامترهای انتخاب شده ')
        API.getSalesChart(params)
            .then((response) => {
                label = [];
                count = [];
                labelAmp = [];
                countAmp = [];

                response.data.saleDay.forEach(element => {

                    label.push(shamsi.gregorianToJalali(element.date).join('/'));
                    count.push(element.count);
                });
                response.data.saleAmp.forEach(element => {

                    labelAmp.push(shamsi.gregorianToJalali(element.date).join('/'));
                    countAmp.push(element.count);
                });
                setIsLoaded(true);

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }


    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={true} title='NGKH'/>


            <section className='container-fluid my-3 py-5 rtl'>
                <div className="row">
                    <div className="col-12">
                        <div className="card info-card ">

                            <div className="card-body rtl row pt-4">
                                <div className="col-5 mb-2">
                                <span className='text-small-2 mx-3'>
                                    از تاریخ
                                </span>
                                    <DatePicker
                                        onChange={(val) => setDateFrom(val)}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        className="rmdp-mobile"

                                    />
                                </div>
                                <div className="col-1">
                                    &nbsp;
                                </div>
                                <div className="col-5 mb-2">
                            <span className='text-small-2 mx-3'>
                                    تا تاریخ
                                </span>
                                    <DatePicker
                                        onChange={(val) => setDateTo(val)}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        className="rmdp-mobile"

                                    />
                                </div>
                                <div className="col-12 my-1">
                                    <Select
                                        options={selectOptions}
                                        placeholder="انتخاب نماینده"
                                        value={selectedOptions}
                                        className=' py-2 '
                                        isSearchable={true}
                                        onChange={
                                            (event) => {
                                                setSelectedOptions(event)
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                        برند
                                    </label>
                                    <select
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={brand}
                                        onChange={
                                            (event) => {
                                                setBrand(event.target.value)
                                            }
                                        }
                                    >
                                        <option value="0">
                                           همه برندها
                                        </option>
                                        {
                                            basics?.brands?.map(bt => {
                                                return (
                                                    <option value={bt.id} key={bt.id}>
                                                        {bt.name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-6 mb-3">
                                    <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                        آمپراژ
                                    </label>
                                    <select
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={amperage}
                                        onChange={
                                            (event) => {
                                                setAmperage(event.target.value)
                                            }
                                        }
                                    >
                                        <option value="0">
                                          همه آمپراژها
                                        </option>
                                        {
                                            basics?.amperages?.map(bt => {
                                                return (
                                                    <option value={bt.title} key={bt.title}>
                                                        {bt.title}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-6 mb-3">
                                    <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                        تیپ باتری
                                    </label>
                                    <select
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={type}
                                        onChange={
                                            (event) => {
                                                setType(event.target.value)
                                            }
                                        }
                                    >
                                        <option value="0">
                                          همه تیپ ها
                                        </option>
                                        {
                                            basics?.types?.map(bt => {
                                                return (
                                                    <option value={bt.title} key={bt.title}>
                                                        {bt.title}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-12 mb-2">
                                    <button className='btn btn-warning w-100 text-small-2'
                                            onClick={onLoadReport}
                                    >
                                        مشاهده گزارش
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">

                        <div className="card text-center">
                            <div className="card-body">
                                <h5 className="card-title fw-bold mb-3">

                                    نمودار فروش محصولات
                                    (تعدادی)

                                    &nbsp;
                                    {
                                        duration
                                    }
                                </h5>
                                <Line
                                    datasetIdKey='id'
                                    data={{
                                        labels: label,
                                        datasets: [
                                            {
                                                id: 1,
                                                label: 'فروش',
                                                data: count,
                                                backgroundColor: 'rgba(1,70,1,0.52)',
                                                borderColor: 'rgba(3,150,3,0.4)',
                                            },

                                        ],
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="col-12 mt-3">

                        <div className="card text-center">
                            <div className="card-body">
                                <h5 className="card-title fw-bold mb-3">

                                    نمودار فروش محصولات
                                    (آمپری)
                                    &nbsp;
                                    {
                                        duration
                                    }
                                </h5>
                                <Line
                                    datasetIdKey='id'
                                    data={{
                                        labels: labelAmp,
                                        datasets: [
                                            {
                                                id: 1,
                                                label: 'فروش',
                                                data: countAmp,
                                                backgroundColor: 'rgba(1,70,1,0.52)',
                                                borderColor: 'rgba(3,150,3,0.4)',
                                            },

                                        ],
                                    }}
                                />
                            </div>
                        </div>

                    </div>

                </div>
            </section>

        </React.Fragment>
    );
};
